export default "__VITE_ASSET__BXJXgPPY__"